import { render } from "./undo.vue?vue&type=template&id=90452e78"
import script from "./undo.vue?vue&type=script&lang=js"
export * from "./undo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__